/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['./localeService'], function(LocaleService) {
    'use strict';
    return new LocaleService();
});



// WEBPACK FOOTER //
// ./config/language/globalLocaleService.js